<template>
<li class="uix-list-item-header"><slot></slot></li>
</template>
<script>
export default {
}
</script>



// WEBPACK FOOTER //
// ListItemTitle.vue?31ce7122